export default class ConfigConnection{
    apiInstance = 'https://apiweb.loyaltyrefunds.com/';
}